import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export type OfflineNotification = { [serverUrl: string]: boolean };

@Injectable({
  providedIn: 'root',
})
export class OfflineService {
  public offlineObservable = new BehaviorSubject<OfflineNotification>({});

  public setOffline(serverUrl: string, offline = true): void {
    this.offlineObservable.next({ [serverUrl]: offline });
  }

  public isOffline(serverUrl: string): boolean {
    return this.offlineObservable.value[serverUrl] ?? false;
  }
}
